"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _O7FALLU5cjs = require('./O7FALLU5.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');

// src/hovercard/hovercard-store.ts
var _hovercardstore = require('@ariakit/core/hovercard/hovercard-store'); var Core = _interopRequireWildcard(_hovercardstore);
function useHovercardStoreProps(store, update, props) {
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "timeout");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "showTimeout");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "hideTimeout");
  return _O7FALLU5cjs.usePopoverStoreProps.call(void 0, store, update, props);
}
function useHovercardStore(props = {}) {
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createHovercardStore, props);
  return useHovercardStoreProps(store, update, props);
}




exports.useHovercardStoreProps = useHovercardStoreProps; exports.useHovercardStore = useHovercardStore;
